var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgFbOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50.0003C38.8072 50.0003 50 38.8074 50 25.0002C50 11.1929 38.8072 0 25 0C11.1929 0 0 11.1929 0 25.0002C0 38.8074 11.1929 50.0003 25 50.0003Z",
    fill: "#FF7A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2022 16.7773C21.2022 17.4999 21.2022 20.7226 21.2022 20.7226H18.3115V25.5468H21.2022V38.7696H27.1397V25.5371H31.124C31.124 25.5371 31.4951 23.2226 31.6807 20.6933C31.1631 20.6933 27.169 20.6933 27.169 20.6933C27.169 20.6933 27.169 17.8905 27.169 17.3925C27.169 16.9042 27.8135 16.2401 28.458 16.2401C29.0928 16.2401 30.4404 16.2401 31.6904 16.2401C31.6904 15.5858 31.6904 13.3104 31.6904 11.2206C30.0205 11.2206 28.126 11.2206 27.2959 11.2206C21.0557 11.2303 21.2022 16.0546 21.2022 16.7773Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbOrange);
export default __webpack_public_path__ + "static/media/fb_orange.27ab4d2f9e3731e63cf4057032927770.svg";
export { ForwardRef as ReactComponent };